import { render, staticRenderFns } from "./resetModal.vue?vue&type=template&id=1ec26a92&"
import script from "./resetModal.vue?vue&type=script&lang=js&"
export * from "./resetModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports